import React, { useState } from "react"
import { Link } from "gatsby"

import Container from "../container/container"

import * as styles from "./slider.module.scss"
import prev from "../../assets/testimonials/slider-arrow-prev.svg"
import next from "../../assets/testimonials/slider-arrow-next.svg"

import Markdown from "react-markdown"

const TestimonialSlider = props => {
  const [currentSlide, setCurrentSlide] = useState(0)

  function nextSlide() {
    if (currentSlide === props.data.Testimonials.length - 1) {
      setCurrentSlide(0)
    } else {
      setCurrentSlide(currentSlide + 1)
    }
  }

  function prevSlide() {
    if (!currentSlide) {
      setCurrentSlide(props.data.Testimonials.length - 1)
    } else {
      setCurrentSlide(currentSlide - 1)
    }
  }

  return (
    <div className={styles.testimonials}>
      <img
        src={prev}
        alt="Previous"
        className={styles.testimonials__prev}
        onClick={prevSlide}
      />
      <img
        src={next}
        alt="Next"
        className={styles.testimonials__next}
        onClick={nextSlide}
      />
      <Container>
        <h2>Testimonials</h2>
        <h3>Here is what some of my clients have to say:</h3>
        <div>
          {props.data.Testimonials.map(
            (test, key) =>
              key === currentSlide && (
                <div key={key} className={styles.testimonials__slider}>
                  <div className={styles.testimonials__slider__image}>
                    <div
                      className={styles.testimonials__slider__image__bg}
                    ></div>
                    <div className={styles.testimonials__slider__image__wrap}>
                      <img src={test.Image.publicURL} alt={test.Name} />
                    </div>
                  </div>
                  <div className={styles.testimonials__slider__content}>
                    <Markdown>{test.Body}</Markdown>
                    <strong>
                      {test.Name}, {test.Company}
                    </strong>
                  </div>
                </div>
              )
          )}
        </div>
      </Container>
    </div>
  )
}

export default TestimonialSlider
